import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import {
  makeStyles,
  Box,
  Card,
  CardActionArea,
  CardContent,
  Typography,
} from '@material-ui/core';

import { formatCurrencyValue } from '../../utils/helpers';

import ActiveDot from '../ActiveDot';

import styles from './styles';

const useStyles = makeStyles(styles);

const BalancesList = ({ data, onClickItem }) => {
  const classes = useStyles();

  const CardActionContainer = useMemo(
    () => (onClickItem !== undefined ? CardActionArea : Box),
    [onClickItem],
  );

  return (
    <Box className={classes.container}>
      {data.map((item) => (
        <Card key={`balance-item-${item.name}`} className={classes.card}>
          <CardActionContainer onClick={() => onClickItem?.(item)}>
            <CardContent className={classes.cardContent}>
              {item.active !== undefined && (
                <Box className={classes.cardContentActiveDot}>
                  <ActiveDot isActive={item.active} fontSize="default" />
                </Box>
              )}

              <Box
                component="img"
                src={item.icon}
                alt={`${item.name} Icon`}
                width={40}
                height={40}
              />

              <Typography style={{ fontWeight: 'bold' }}>
                {item.name}
              </Typography>

              <Typography>
                {formatCurrencyValue(item.amount, { style: 'decimal' })}
              </Typography>
            </CardContent>
          </CardActionContainer>
        </Card>
      ))}
    </Box>
  );
};

BalancesList.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.number.isRequired,
      icon: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      id: PropTypes.string,
      active: PropTypes.bool,
    }),
  ).isRequired,
  onClickItem: PropTypes.func,
};

BalancesList.defaultProps = {
  onClickItem: undefined,
};

export default BalancesList;
